export const environment = {
  production: false,
  existingCaseWorthyAPIURL:
    "https://dev.caseworthy.com/CaseWorthy_NextGen.API/",
  nextGenAccountsAPIURL: "https://api.cwe.dev.caseworthy.com/account/services/v1/",
  nextGenFormsAPIURL: "https://api.cwe.dev.caseworthy.com/forms/services/v1/",
  nextGenQueryAPIURL: "https://api.cwe.dev.caseworthy.com/query-apbuilder/services/v1/",
  nextGenServerUrl: "https://api.cwe.dev.caseworthy.com/"
}